import { connect } from 'react-redux';
import RequestsAndChanges from './requestsAndChanges'
import * as AC from '../../../actions/actionCreators'
import { getSetting } from '../../../util/helpers'

function mapStateToProps(state) { 
	return {
        profile: state.profile,
        settings: state.setting.settings,
        isLoading: state.setting.isLoading,
        users: state.user.users
            .filter((u) => (u.role || '').toUpperCase() === 'VISITOR')
            .map((u) => ({ value: u.visitorTerritory, key: u.id, text: u.name + ' (' + u.visitorTerritory + ')' })),
        isSaving: state.setting.isSaving,
        error: state.setting.error,
        errorRequest: state.request.error,
        errorPanelChange: state.panelChange.error,
        requests: state.request.requests,
        panelChanges: state.panelChange.panelChanges,        
        isPanelOpen: getSetting(state.setting.settings, "isPanelOpen") === undefined ? undefined : getSetting(state.setting.settings, "isPanelOpen") === "true",
        showPanelConsent: getSetting(state.setting.settings, "showPanelConsent") || "",
}};

function mapDispatchToProps(dispatch) {
    return({
        setRequestProcessed: (id, status) => { dispatch(AC.RequestsSetStatusStarted(id, status)) },
        setPanelChangeProcessed: (id, status) => { dispatch(AC.PanelChangesSetStatusStarted(id, status)) },
        fetchUsers: (rsm) => { dispatch(AC.UserListLoadingStarted(rsm) ) },
        fetchRequests: (visitorTerritory) => { dispatch(AC.RequestsLoadingStarted(visitorTerritory) ) },
        fetchPanelChanges: (visitorTerritory, detailed) => { dispatch(AC.PanelChangesLoadingStarted(visitorTerritory, detailed) ) },        
        fetchSettings: () => { dispatch(AC.SettingLoadingStarted() ) },
        setSetting: (key, value) => { dispatch(AC.SettingSaveStarted(key, value) ) },
        clearRequestUi: () => { dispatch(AC.ClearRequestUi()) },
        clearPanelChangeUi: () => { dispatch(AC.ClearPanelChangeUi()) },
        clearSettingUi: () => { dispatch(AC.ClearSettingUi()) },
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestsAndChanges);